export const TOKEN_KEY = 'thrift-client-token';
export const RECENT_VIEW_KEY = 'thrift-recently-viewed';
export const SEARCH_KEY = 'thrift-search-key';
export const SELECTED_CITY = 'thrift-selected-city';